// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import BasicDetailsActionType from './basic-details.types';

const INITIAL_STATE = {
	// Basic Details Response
	basicDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** BASIC DETAILS ADD START *********************** */
		case BasicDetailsActionType.BASIC_DETAILS_ADD_SUCCESS:
			return { ...state, basicDetailsResponse: action.payload };

		case BasicDetailsActionType.BASIC_DETAILS_ADD_FAILURE:
			return { ...state, basicDetailsResponse: action.payload };

		case BasicDetailsActionType.BASIC_DETAILS_ADD_RESPONSE_CHANGED:
			return { ...state, basicDetailsResponse: null };
		/** ***************** BASIC DETAILS ADD END *********************** */


		default:
			return state;
	}
};
